import { service } from ".";

export default {
  getAll: () => service.get("/feedbacks"),
  getOne: (id) => service.get(`/feedbacks/${id}`),
  getAllPaginate: (query) => service.get(`/feedbacks/paginate?${query}`),
  create: (data) => service.post("/feedbacks", data),
  update: (id, data) => service.put(`/feedbacks/${id}`, data),
  delete: (id) => service.delete(`/feedbacks/${id}`),
};
